var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"grid grid-cols-1 gap-6 sm:grid-cols-2",attrs:{"role":"list"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }